<template>
  <!-- 多选下拉：最多展示 max 个标签，超出部分以 +N 显示 -->
  <div class="limit-select" :class="{ 'has-more': hiddenCount > 0 }">
    <el-select
      :value="shown"
      multiple
      filterable
      :placeholder="placeholder"
      style="width: 100%"
      @change="handleChange">
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
    <span v-if="hiddenCount > 0" class="limit-select__more">+{{ hiddenCount }}</span>
  </div>
</template>

<script>
export default {
  name: 'LimitSelect', // 多选下拉（标签限量展示，超出 +N）
  props: {
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    // 最多展示的标签个数，超出显示 +N
    max: {
      type: Number,
      default: 5
    }
  },
  computed: {
    shown () {
      return this.value.slice(0, this.max)
    },
    hiddenCount () {
      return Math.max(0, this.value.length - this.max)
    }
  },
  methods: {
    /**
     * 展示值（前 max 个）变化后差量合并回完整值：被删的移除、新增的追加
     */
    handleChange (val) {
      const prevShown = this.shown
      const removed = prevShown.filter(id => !val.includes(id))
      const added = val.filter(id => !prevShown.includes(id))
      const next = this.value.filter(id => !removed.includes(id)).concat(added)
      this.$emit('input', next)
      this.$emit('change', next)
    }
  }
}
</script>

<style lang="scss" scoped>
.limit-select {
  position: relative;
  width: 100%;
  &.has-more {
    // 给 +N 徽标预留位置，避免标签被遮挡
    ::v-deep .el-select .el-select__tags {
      padding-right: 44px;
    }
  }
  .limit-select__more {
    position: absolute;
    top: 50%;
    right: 32px;
    transform: translateY(-50%);
    background-color: #F0F2F5;
    border-radius: 4px;
    padding: 2px 6px;
    font-size: 12px;
    color: #909399;
    pointer-events: none;
  }
}
</style>
